import styled from 'styled-components';

import { WEBAPP_BORDER_RADIUS } from 'src/config/constants';

export const TableWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.primary.base.white};
  border-radius: ${WEBAPP_BORDER_RADIUS};
`;
